import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";

@Component({
  selector: 'app-campaign-settings-compliance',
  standalone: true,
  imports: [CardModule, InputTextModule, DropdownModule, GenericButtonComponent, ToastModule ],
  templateUrl: './campaign-settings-compliance.component.html',
  styleUrl: './campaign-settings-compliance.component.scss'
})
export class CampaignSettingsComplianceComponent {

}
